import React, { useState } from 'react';

const faqData = [
  { q: "Can I work on multiple devices?", a: "Yes, you can log in across multiple devices, and your works are synced with backups on the server." },
  { q: "Does the whole application work offline?", a: "Internet access is required" },
  { q: "Can works be exported?", a: "Yes, works can be exported to PDF formats." },
  { q: "Are Area, Floor, etc. charges included in Rate Analysis?", a: "Yes, they are automatically calculated based on the selected parameters. *Coming Soon*" },
  { q: "Can I link drawing measurements to item measurements?", a: "Yes, drawing measurements can be linked and auto-updated. *Coming Soon*" },
  { q: "Can I import existing drawings from another application?", a: "Yes, existing drawings can be imported in multiple formats. *Coming Soon*" },
  { q: "What files can I attach to work?", a: "You can attach PDFs, images, spreadsheets, and more. *Coming Soon*" },
  { q: "Where can I track submitted works?", a: "Submitted works can be tracked via the dashboard under the 'Mywork' section." },
];

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="my-16">
      <div className="text-center mb-10">
        <h2 className="text-4xl font-bold">FAQs</h2>
      </div>
      <div className="max-w-3xl mx-auto space-y-4">
        {faqData.map((faq, index) => (
          <div key={index} className="bg-white rounded shadow-md">
            <div
              className="flex justify-between items-center p-4 font-semibold cursor-pointer"
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              {faq.q}
              <span className="transform transition-transform" style={{ transform: openIndex === index ? "rotate(180deg)" : "rotate(0deg)" }}>▼</span>
            </div>
            {openIndex === index && (
              <div className="px-4 pb-4 text-gray-700">{faq.a}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQs;